import { createFileRoute } from '@tanstack/react-router';
import { analyticsStaticData } from '../../../../../analytics';

export const Route = createFileRoute(
  '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction/'
)({
  staticData: analyticsStaticData
});
